import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import axios from './axios';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import StudentList from './components/Students/StudentList';
import AddStudent from './components/Students/AddStudent';
import EditStudent from './components/Students/EditStudent';
import UploadForm from './components/Students/UploadForm';
import StudentSearch from './components/Students/StudentSearch'; // Import StudentSearch
import Header from './components/Header';
import ConfigurationList from './components/ConfigurationList';
import 'bootstrap/dist/css/bootstrap.min.css';
import ManageMajors from './components/admissions/ManageMajors';
import ManageClasses from './components/admissions/ManageClasses'; // Import the new form
import EnrollmentListPage from './components/admissions/EnrollmentListPage'; // Import the new form
import UserListPage from './components/Users/UserListPage';
import UnauthorizedPage from './components/UnauthorizedPage'; // Import trang UnauthorizedPage
import StudentReception from './components/admissions/StudentReceptionPage'; // StudentReception
import LogPage from './components/Auth/LogPage';

const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const res = await axios.get('/auth/me', {
            headers: { 'x-auth-token': token }
          });
          setUser(res.data);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchUser();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <Router>
      <div>
        {user && <Header user={user} onLogout={handleLogout} />}
        <Routes>
          {user ? (
            <>
              {['admin', 'manager'].includes(user.role) && (
                <Route path="/student-reception" element={<StudentReception />} />
              )}
              {user.role === 'admin' ? (
                <>
                  <Route path="/students" element={<StudentList />} />
                  <Route path="/add-student" element={<AddStudent />} />
                  <Route path="/edit-student/:id" element={<EditStudent />} />
                  <Route path="/configurations" element={<ConfigurationList />} />
                  <Route path="/upload" element={<UploadForm />} />
                  <Route path="/manage-majors" element={<ManageMajors />} />
                  <Route path="/manage-classes/:majorId" element={<ManageClasses />} />
                  <Route path="/enrollments" element={<EnrollmentListPage />} />
                  <Route path="/manage-users" element={<UserListPage />} />
                  <Route path="/logs" element={<LogPage/>} />
                  <Route path="*" element={<Navigate to="/students" />} />
                </>
              ) : (
                <Route path="*" element={<Navigate to="/unauthorized" />} />
              )}
            </>
          ) : (
            <>
              <Route path="/search" element={<StudentSearch />} />
              <Route path="/login" element={<Login setUser={setUser} />} />
              <Route path="/register" element={<Register />} />
              <Route path="/" element={<Navigate to="/search" />} />
              <Route path="*" element={<Navigate to="/search" />} />
            </>
          )}
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
